import { ReactNode } from 'react';
import { PageContainer } from './PageContainer';
import { PageHeader } from './PageHeader';
import { Section } from './Section';

interface PageLayoutProps {
    title: string;
    description?: string;
    children: ReactNode;
    actions?: ReactNode;
    className?: string;
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'container' | 'wide' | 'full';
    padding?: 'none' | 'sm' | 'md' | 'lg' | 'responsive' | 'mobile-minimal';
    spacing?: 'sm' | 'md' | 'lg' | 'xl';
    background?: 'transparent' | 'white' | 'gray' | 'gradient';
    border?: boolean;
    rounded?: boolean;
}

/**
 * 全ページで統一されたレイアウトコンポーネント
 * 一貫したページ構造、タイトル、説明、アクション配置を提供
 * 重複を避け、統一感のあるデザインを実現
 */
export const PageLayout: React.FC<PageLayoutProps> = ({
    title,
    description,
    children,
    actions,
    className,
    maxWidth = 'container',
    padding = 'responsive',
    spacing = 'md',
    background = 'transparent',
    border = false,
    rounded = false
}) => {
    return (
        <PageContainer maxWidth={maxWidth} padding={padding} className={className}>
            <PageHeader title={title} description={description}>
                {actions}
            </PageHeader>
            <Section
                spacing={spacing}
                background={background}
                border={border}
                rounded={rounded}
            >
                {children}
            </Section>
        </PageContainer>
    );
};
